/**
 * Normalize legacy Quill / Word HTML before TipTap setContent.
 */
export function normalizeEditorHtml(html: string): string {
  if (!html?.trim()) return ''
  if (typeof DOMParser === 'undefined') return html

  try {
    const doc = new DOMParser().parseFromString(
      `<div id="__rte_root">${html}</div>`,
      'text/html'
    )
    const root = doc.getElementById('__rte_root')
    if (!root) return html

    // Unwrap Quill htmlTable embeds → real <table>
    root.querySelectorAll('.ql-html-table').forEach((wrap) => {
      const inner = wrap.querySelector('.ql-html-table-inner')
      const table = (inner || wrap).querySelector('table')
      if (table) {
        wrap.replaceWith(table.cloneNode(true))
      } else if (inner) {
        wrap.replaceWith(...Array.from(inner.childNodes))
      }
    })

    // Light Word junk cleanup (keep tables)
    root.querySelectorAll('o\\:p, w\\:sdt').forEach((n) => n.remove())

    return root.innerHTML
  } catch {
    return html
  }
}

/** Soft-clean pasted HTML from Word while preserving tables/images */
export function transformPastedHtml(html: string): string {
  if (!html) return html
  let out = html
  // Salvage tables then strip mso conditionals
  const tables: string[] = []
  out = out.replace(/<table\b[\s\S]*?<\/table>/gi, (t) => {
    const token = `__TIP_TBL_${tables.length}__`
    tables.push(t)
    return token
  })
  out = out
    .replace(/<!--\[if[\s\S]*?<!\[endif\]-->/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<\/?(o:|v:|w:|m:)[^>]*>/gi, '')
    .replace(/<xml[\s\S]*?<\/xml>/gi, '')
    .replace(/\sclass="?Mso[^"\s]*"?/gi, '')
  tables.forEach((t, i) => {
    out = out.split(`__TIP_TBL_${i}__`).join(t)
  })
  // Unwrap legacy quill table wrappers if present in paste
  out = out.replace(
    /<div[^>]*class="[^"]*ql-html-table[^"]*"[^>]*>\s*<div[^>]*class="[^"]*ql-html-table-inner[^"]*"[^>]*>([\s\S]*?)<\/div>\s*<\/div>/gi,
    '$1'
  )
  return out
}
